import { call } from 'redux-saga/effects';
import { createForecast } from 'store/glue/operation/createForecast';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as forecastActions from './actions';

// Delegates to the createForecast operation which handles the API call,
// the aggregated-forecast domain dispatch, and toast/error handling.
export function* startCreateForecastSaga(
  action: ActionType<typeof forecastActions.startCreateForecast>,
) {
  function* saga() {
    const { zoneId, date, value } = action.payload;
    yield call(createForecast, { zoneId, date, value });
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
